// @flow

import styled from 'styled-components';

export const InputHolder = styled.div`
  grid-column: 1/3;
  &:empty {
    display: none;
  }
`;
